function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_914_2555)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M3.19103 7.31945L0.908472 3.51442C0.508636 2.84789 0.988755 2 1.76601 2H22.734C23.5112 2 23.9914 2.84789 23.5915 3.51442L21.309 7.31945C21.1283 7.62069 20.8027 7.80503 20.4514 7.80503H4.04857C3.69728 7.80503 3.37175 7.62069 3.19103 7.31945Z",
  fill: "#D18F1F"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.60851 15.0081L5.34651 11.2196C4.94853 10.5531 5.42879 9.70697 6.20512 9.70697H18.2956C19.0719 9.70697 19.5522 10.5531 19.1542 11.2196L16.8922 15.0081C16.7117 15.3104 16.3856 15.4955 16.0336 15.4955H8.46711C8.11508 15.4955 7.78897 15.3104 7.60851 15.0081Z",
  fill: "#D18F1F"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.3929 21.7754L9.67063 18.9129C9.26962 18.2464 9.74965 17.3973 10.5275 17.3973H13.972C14.7498 17.3973 15.2298 18.2464 14.8288 18.9129L13.1066 21.7754C12.7179 22.4213 11.7815 22.4213 11.3929 21.7754Z",
  fill: "#D18F1F"
}));
var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_914_2555"
}, /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 24,
  fill: "white"
})));
function SvgFunnel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFunnel);
export default __webpack_public_path__ + "static/media/funnel.4d986ac260c7aea40697a42eaee2757d.svg";
export { ForwardRef as ReactComponent };